type BenefitIconProps = {
  className?: string;
};

const DEALSAWAY_BENEFIT_COLORS = {
  accent: '#FFD9C2',
  divider: '#F0CAD0',
  icon: '#E8344E',
  label: '#333539',
  surface: '#FFEFF2',
  tileBorder: '#F5C4CB',
} as const;

const sharedIconProps = {
  'aria-hidden': true,
  'data-testid': 'benefit-icon',
  fill: 'none',
  focusable: false,
  stroke: 'currentColor',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  strokeWidth: 1.75,
  viewBox: '0 0 24 24',
  xmlns: 'http://www.w3.org/2000/svg',
};

const PaperPlaneIcon = ({ className }: BenefitIconProps) => (
  <svg {...sharedIconProps} className={className} data-icon="paper-plane">
    <path
      d="M21 3 3 10.2l7.2 3.6L13.8 21z"
      data-testid="paper-plane-body"
      fill="#CFEBA0"
    />
    <path d="M10.2 13.8 21 3" data-testid="paper-plane-fold" />
    <path
      d="M3 17.5h3.2M5 21h2.6"
      data-testid="paper-plane-trails"
      strokeOpacity={0.55}
    />
  </svg>
);

const CoordinatorIcon = ({ className }: BenefitIconProps) => (
  <svg {...sharedIconProps} className={className} data-icon="coordinator">
    <circle cx="8.5" cy="8.2" data-testid="coordinator-head" r="3.1" />
    <path
      d="M2.5 20.5c.5-3.6 3.1-5.8 6-5.8s5.5 2.2 6 5.8"
      data-testid="coordinator-body"
    />
    <path
      d="M15 3.2h5.2a1.8 1.8 0 0 1 1.8 1.8v3.4a1.8 1.8 0 0 1-1.8 1.8h-2.4l-2.3 2.2v-2.2H15a1.8 1.8 0 0 1-1.8-1.8V5A1.8 1.8 0 0 1 15 3.2z"
      data-testid="coordinator-bubble"
      fill="#CFEBA0"
    />
  </svg>
);

const PaymentCardIcon = ({ className }: BenefitIconProps) => (
  <svg {...sharedIconProps} className={className} data-icon="payment-card">
    <rect
      data-testid="payment-card-body"
      height="12.5"
      rx="2.4"
      width="18"
      x="2"
      y="5"
    />
    <path d="M2 9.5h18M5.5 13.8h3.5" data-testid="payment-card-details" />
    <circle
      cx="18"
      cy="17.5"
      data-testid="payment-card-badge"
      fill="#CFEBA0"
      r="4.4"
    />
    <path d="m16 17.6 1.5 1.5 2.7-2.9" data-testid="payment-card-check" />
  </svg>
);

const AtiaAccreditedIcon = ({ className }: BenefitIconProps) => (
  <svg {...sharedIconProps} className={className} data-icon="atia-accredited">
    <path
      d="M12 3 19.5 5.8v5.7c0 4.5-3.1 7.9-7.5 9.5-4.4-1.6-7.5-5-7.5-9.5V5.8z"
      data-testid="atia-shield"
      fill={DEALSAWAY_BENEFIT_COLORS.accent}
    />
    <path d="m8.6 12 2.4 2.4 4.4-4.8" data-testid="atia-check" />
  </svg>
);

const AussieServicedIcon = ({ className }: BenefitIconProps) => (
  <svg {...sharedIconProps} className={className} data-icon="aussie-serviced">
    <path
      d="M16.4 4 17.2 6.6 21.4 12.1 20.6 15.1 17.6 17 14.6 15.6 11 14 6.7 15.1 3.4 15.3 2.7 11.1 2.9 9.4 6.8 7.5 8.6 5.6 10.3 5.9 10.9 4.8 13.8 4.7 14.8 7.3 15.9 6.2z"
      data-testid="aussie-mainland"
      fill={DEALSAWAY_BENEFIT_COLORS.accent}
    />
    <path
      d="M15.8 19.2h2.8l-.8 2.2-1.4-.2z"
      data-testid="aussie-tasmania"
      fill={DEALSAWAY_BENEFIT_COLORS.accent}
    />
  </svg>
);

const BestDealGuaranteeIcon = ({ className }: BenefitIconProps) => (
  <svg
    {...sharedIconProps}
    className={className}
    data-icon="best-deal-guarantee"
  >
    <path
      d="M12 3 19.5 5.8v5.7c0 4.5-3.1 7.9-7.5 9.5-4.4-1.6-7.5-5-7.5-9.5V5.8z"
      data-testid="best-deal-shield"
      fill={DEALSAWAY_BENEFIT_COLORS.accent}
    />
    <path
      d="M12 8.3v7.4M14.1 9.6c-.5-.5-1.3-.8-2.1-.8-1.3 0-2.3.7-2.3 1.7 0 .9.8 1.4 2.3 1.7 1.5.3 2.3.8 2.3 1.7 0 1-1 1.7-2.3 1.7-.8 0-1.6-.3-2.1-.8"
      data-testid="best-deal-dollar"
      strokeWidth={1.5}
    />
  </svg>
);

export {
  AtiaAccreditedIcon,
  AussieServicedIcon,
  BestDealGuaranteeIcon,
  CoordinatorIcon,
  DEALSAWAY_BENEFIT_COLORS,
  PaperPlaneIcon,
  PaymentCardIcon,
};
